enum DataExtractFormat {
    Excel = 'Excel',
    CSV = 'CSV',
}

export default DataExtractFormat;
